import {postCreateJackpot} from '../api/postCreateJackpot';

const setPostCreateJackpot = (params, setOpenModalSuccess, setOpenModalError) => {
    return async (dispatch, getState) => {
        try {
            await postCreateJackpot(params);
            setOpenModalSuccess(true);          
        } catch(error) {
            setOpenModalError(true)
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateJackpot
}